const roleTypes = [
  { label: "Admin", value: "1" },
  { label: "Staff", value: "2" },
  { label: "User", value: "3" },
  { label: "Test", value: "4" },
];

export const roleTypeOptions = (roleName?: string) => {
  if (roleName?.toLowerCase() === "admin") {
    return roleTypes;
  }

  return roleTypes.filter(
    (role) => role.label === "User" || role.label === "Test"
  );
};
